import { render, staticRenderFns } from "./ResetPassByEmailPage.vue?vue&type=template&id=14f8e54e&"
import script from "./ResetPassByEmailPage.vue?vue&type=script&lang=js&"
export * from "./ResetPassByEmailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports